<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="TPO: Practices and Trainings Conducted"
                   :links="[{title:'Home', url:'/'},{title:'TPO: Practices and Trainings Conducted'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="5"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Practices</div>
          <blockquote class="about-message">
            <p>Training & Placement Cell of SNDCOE & RC provides the soft skills and technical training for the
              enhancement of Students Skill. The training begins in the first year of degree course and continues till
              the BE final year. The training allows the students to explore their talents and skills and enhance their
              potential.</p>

            <p>T & P Cell focus for the First year students on communication skills and intra personal skills which
              include programs on Personality Development, Presentation skills, Goal Setting, Confidence building. The
              second year and third year focuses on aptitude preparation, group discussion and interview skill. In final
              year students are given company specific training. In addition to soft skill training, technical training
              in respective domain, higher studies guidance, competitive examination guidance is also provided to the
              students.</p>

          </blockquote>

          <div class="heading-black1">Trainings Conducted</div>
          <activity-component v-for="training in trainings" :key="training" :activity="training"></activity-component>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/tpo/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import ActivityComponent from "@/components/ActivityComponent";

export default {
  name: "PracticesTrainings",
  components: {
    KeyRecruiters,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    ActivityComponent
  },
  data(){
    return{
      trainings:[
        {
          name: "Barclays Connect with Work Training Programme",
          date: "4 to 6 January 2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/tpo/trainings/tr1/1.jpg",
              "thumbnailImageSrc": "",
              "alt": "",
              "title": ""
            },

          ]
        }
      ]
    }
  }

}
</script>
<style lang="scss" scoped/>
